import { request } from '../../../global/services/request'

export async function getPartnerSummary(partnerId: string) {
  return await request({
    path: `/resellers/${partnerId}?include=stats`,
    method: 'GET'
  })
}

export async function getPartnerSubscriptionChartData(partnerId: string) {
  return await request({
    path: `/resellers/${partnerId}/graphs/subscription_status?interval=P1M&include=deactivated`,
    method: 'GET'
  })
}
